<div class="position-relative min-vh-100">

  <!-- 🔘 Floating Theme Toggle -->
  <div class="position-fixed top-0 end-0 p-3 z-3">
    <app-theme-toggle-button></app-theme-toggle-button>
  </div>

  <!-- 404 Content -->
  <div class="d-flex flex-column align-items-center justify-content-center min-vh-100 p-4 overflow-hidden">

    <div class="mx-auto w-100 text-center" style="max-width: 472px;">
      <h1 class="mb-4 fw-bold">
        ERROR
      </h1>

      <!-- Light mode image -->
      <img
        src="assets/svg/error/404.svg"
        alt="404"
        class="img-fluid mb-3"
        style="max-width: 242px;"
      />

      <!-- Dark mode image -->
      <img
        src="assets/svg/error/404-dark.svg"
        alt="404"
        class="img-fluid mb-3 d-none d-dark-block"
        style="max-width: 242px;"
      />

      <p class="mt-4 mb-4 fs-6">
        We can’t seem to find the page you are looking for!
      </p>

      <a
        routerLink="/"
        class="btn btn-outline-danger px-4 py-2 shadow-sm"
      >
        Back to Home Page
      </a>
    </div>

    <p class="position-absolute bottom-0 start-50 translate-middle-x mb-3 text-center small">
      &copy; {{ currentYear }} - Eventz
    </p>

  </div>
</div>
